import { Text, View } from '@react-pdf/renderer'

import { SystemAction } from '@/graphql/generated/schemas'

import { CannedIncidentActionType, NonActionItem } from '../../types/feedTypes'
import { styles } from '../styles/styles'
import { ReportDetailsIProps } from '../types/types'
import {
  formatReportTimestamp,
  getActionPerformed,
  getActionUser,
  getUserNameAndRole,
  isAudioOrNote,
  isNotAssignment,
  shouldDisplayDateForAction,
  userAction,
} from '../utils/utils'
import { SectionTitle } from './SectionTitle'

export const Details = ({
  timeline,
  incidentDescription,
  createdAt,
  timeZone,
}: ReportDetailsIProps) => {
  return (
    <View style={styles.section}>
      <SectionTitle icon='timeline' title='Timeline feed' />
      <View style={styles.timelineRow}>
        <Text style={styles.timelineDate}>
          {formatReportTimestamp(createdAt, timeZone)}
        </Text>
        <Text style={styles.timelineMessage}>{incidentDescription}</Text>
      </View>

      {timeline.length > 0 &&
        timeline.map((action, i) => {
          const shouldRenderDate = shouldDisplayDateForAction(action)
          const shouldRenderSystemMessage = isNotAssignment(action)
          const timelineUserAction = userAction(action)

          if (
            !shouldRenderDate &&
            !shouldRenderSystemMessage &&
            !timelineUserAction
          ) {
            return null
          }

          return (
            <View key={i} style={styles.timelineRow}>
              <Text style={styles.timelineDate}>
                {shouldRenderDate
                  ? formatReportTimestamp(action.createdAt, timeZone)
                  : ''}
              </Text>
              {shouldRenderSystemMessage && (
                <Text style={styles.timelineMessage}>
                  {(action as unknown as SystemAction).systemMessage}
                </Text>
              )}
              {timelineUserAction && (
                <View style={styles.timelineMessage}>
                  <Text>
                    {getActionUser(action)}
                    {isAudioOrNote(action) &&
                      getActionPerformed(
                        action?.__typename as unknown as NonActionItem
                      )}
                    {action.__typename === 'IncidentAction' &&
                      getActionPerformed(
                        action?.type,
                        action?.history,
                        action?.emailRecipients?.length,
                        action?.isRuleAction
                      )}
                    {action.__typename === CannedIncidentActionType.Email &&
                      getUserNameAndRole(action)}
                  </Text>
                  {action.__typename === NonActionItem.IncidentNote && (
                    <View>
                      <Text style={styles.mt2}>{action?.message}</Text>
                      {action?.media?.length > 0 && (
                        <Text style={styles.mt2}>
                          {action.media.length} file(s) were attached
                        </Text>
                      )}
                    </View>
                  )}
                </View>
              )}
            </View>
          )
        })}
      <View style={styles.sectionDivider} />
    </View>
  )
}
